import request from "../index.js";

export const applelogin = (data) =>
    request.post("/web/user/apple-login", data);

export const googlelogin = (data) =>
    request.post("/web/user/google-login", data);

export const oauthlogin = (data) =>
    request.post("/web/user/oauthlogin", data);

export const login = (data) =>
    request.post("/web/user/login", data);

export const peek = (data, config) =>
    request.post("/web/user/peek", data, config);

export const Logout = () => request.post("/web/user/logout");

export const sendverifysms = (data) =>
    request.post("/web/user/sendverifysms", data);

export const uploadmedia = (data, config = { headers: { 'Content-Type': 'multipart/form-data' } }) =>
    request.post("/web/user/uploadmedia", data, config);

export const profilesetting = (data) =>
    request.post("/web/user/profilesetting", data);

export const getTeamList = (data) =>
    request.post("/web/user/get-team-list", data);

export const handleLevel = () =>
    request.get("level/user-level-list");

